module.exports = __webpack_public_path__ + "static/media/808Knob--tempo.e3de5f73.svg";